import {BaseContainerModel} from '../base-container.model';
import {bl_applet_to_catalog_link_RowClass} from '../../dbschema';

export class AppletCatalogContainerModel extends BaseContainerModel {
  bl_applet_to_catalog_link: bl_applet_to_catalog_link_RowClass = new bl_applet_to_catalog_link_RowClass();
}
